import { render, staticRenderFns } from "./RelatoriosAdm.vue?vue&type=template&id=2b047ed8&"
import script from "./RelatoriosAdm.vue?vue&type=script&lang=js&"
export * from "./RelatoriosAdm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports